import React from 'react';

import { SearchOutlined } from '@ant-design/icons';
import { Drawer, Input } from 'antd';

import type { MobileSelectSheetProps } from './MobileSelectSheet.types';
import styles from './styles.module.less';

const MobileSelectSheet = React.memo(
  ({
    children,
    contentSized = false,
    height = '75vh',
    onClose,
    onSearch,
    searchAriaLabel,
    searchPlaceholder,
    searchValue = '',
    title,
    visible,
    zIndex = 1200,
  }: MobileSelectSheetProps) => (
    <Drawer
      className={
        contentSized
          ? `${styles.mobileSelectSheet} ${styles.contentSized}`
          : styles.mobileSelectSheet
      }
      closable
      destroyOnClose
      height={contentSized ? 'auto' : height}
      placement="bottom"
      title={title}
      visible={visible}
      width="100%"
      zIndex={zIndex}
      onClose={onClose}
    >
      <div className={styles.content}>
        {onSearch ? (
          <Input
            aria-label={searchAriaLabel}
            className={styles.search}
            placeholder={searchPlaceholder}
            prefix={<SearchOutlined aria-hidden="true" />}
            value={searchValue}
            onChange={event => onSearch(event.target.value)}
          />
        ) : null}
        <div className={styles.body}>{children}</div>
      </div>
    </Drawer>
  ),
);

export default MobileSelectSheet;
